import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UiKitModule } from '@serviceplan/ui-kit';
import { ClientCoreModule, MatComponentsModule } from '@thehubz/client/core';
import { ApiModule } from '@thehubz/client/data-access-api';
import { ConfirmEmailComponent } from './components/confirm-email/confirm-email.component';
import { LoginComponent } from './components/login/login.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpSuccessComponent } from './components/sign-up-success/sign-up-success.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { LoginRoutingModule } from './login-routing.module';

export const ModuleConfig = 'config';
export interface ClientLoginAndRegistrationModuleConfig {
  enableSingUp: boolean;
  logoLink?: string;
  logoLinkExternal?: boolean;
}

@NgModule({
  declarations: [LoginComponent, SignInComponent, SignUpComponent, SignUpSuccessComponent, ConfirmEmailComponent],
  imports: [CommonModule, LoginRoutingModule, MatComponentsModule, FormsModule, ReactiveFormsModule, ApiModule, ClientCoreModule, UiKitModule],
})
export class ClientLoginAndRegistrationModule {
  static forRoot(config: ClientLoginAndRegistrationModuleConfig): ModuleWithProviders<ClientLoginAndRegistrationModule> {
    return {
      ngModule: ClientLoginAndRegistrationModule,
      providers: [{ provide: ModuleConfig, useValue: config }],
    };
  }
}
